import { service } from '.'
import moment from 'moment'

export interface SubjectData { supNo: string, model: string, capacity: string, mara: string, price: string, productNo: string, productCategory: string, launchDay: string }
export interface PriceBandData { dealerNo: string, productCategory: string, paymentType: string, scopeType: string, productType: string, premium: string, priceMin: string, priceMax: string, chgDeductible: string, fixDeductible: string, coverageName:string, additionalTerms:string}

class ExcelImportStore {

  importSubjects = async (data: SubjectData[]) => {
    const importData = data.map(({ launchDay, ...item }) => ({ ...item, launchDay: moment(launchDay).format('YYYY-MM-DDTHH:mm:ss')}))
    const res = await service.importSubjects(importData)
    if (res.ok) return Promise.resolve()

    const body = await res.json()

    const msg = body?.detail ?? body?.message
    throw new Error(`${msg}, ${res.status}`)
  }

  importPriceBands = async (data: PriceBandData[]) => {
    const res = await service.importPriceBands(data)
    if (res.ok) return Promise.resolve()

    const body = await res.json()

    const msg = body?.detail ?? body?.message
    throw new Error(`${msg}, ${res.status}`)
  }
}

export const excelImportStore = new ExcelImportStore()